<template>
  <div>
    <my-loading />
    <router-view />
  </div>
</template>
<script>
import MyLoading from '../../common/components/loading.vue';
export default {
  name: 'index_m',
  data() {
    return {
      isLoading: ''
    };
  },
  components: {
    MyLoading
  }
};
</script>



// WEBPACK FOOTER //
// src/module/index_m/App.vue